module.exports = __webpack_public_path__ + "static/media/Mira_MVP_Thumb.9cb318da.png";